<template>
    <div class="onlineDeclaration">
        <div class="top">
            <img class="onlineDeclaration-img" src="../../../assets/images/degreeApplication/onlineDeclaration.png"
                alt="" />
        </div>
        <div class="tips">
            在每年的5月初和11月初根据学院官网通知开放网上申报通道。在申报页面填写个人申报信息时注意填写要求 。申请提交后由学院审批，请关注审批结果。
        </div>
        <div class="cont">
            <div class="cont-title">学位申报报名流程</div>
            <div class="form-box">
                <div class="form-title">个人基本信息</div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm modify-ruleForm">
                    <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item label="姓名" prop="student_title">
                                <el-input style="flex: 8" v-model="ruleForm.student_title" placeholder="请输入姓名"
                                    clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="民族" prop="nat_id">
                                <el-select v-model="nation" placeholder="请选择民族" style="width:100%" clearable filterable
                                    @change="natChange">
                                    <el-option v-for="item in nationList" :key="item.id"
                                        :value="item.id + '-' + item.mzdm + '-' + item.mz" :label="item.mz" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="身份证" prop="identity">
                                <el-input style="flex: 8" v-model="ruleForm.identity" placeholder="请输入身份证" clearable>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="性别" prop="sex">
                                <el-radio-group v-model="sex" style="width:100%" @change="sexChange">
                                    <el-radio label="1-男">男</el-radio>
                                    <el-radio label="2-女">女</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="政治面貌" prop="pol_code">
                                <el-select v-model="politicalOutlook" placeholder="请选择政治面貌" style="width:100%" clearable
                                    filterable @change="polChange">
                                    <el-option value="13-群众" label="群众" />
                                    <el-option value="01-党员" label="党员" />
                                </el-select>
                                <!-- <el-radio-group v-model="politicalOutlook" style="width:100%" @change="polChange">
                                    <el-radio label="13-群众">群众</el-radio>
                                    <el-radio label="01-党员">党员</el-radio>
                                </el-radio-group> -->
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="移动电话" prop="tel">
                                <el-input style="flex: 8" v-model="ruleForm.tel" placeholder="请输入移动电话" clearable>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="出生日期" prop="date_birth">
                                <el-date-picker v-model="ruleForm.date_birth" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择出生日期" clearable style="width: 100%;">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>

                        <el-col :span="8">
                            <el-form-item label="学生来源" prop="source_type">
                                <el-select v-model="ruleForm.source_type" placeholder="请选择学生来源" style="width:100%"
                                    clearable filterable>
                                    <el-option :value="1" label="成教上清寺高教自考辅导站学生" />
                                    <el-option :value="2" label="成教其他学生" />
                                    <el-option :value="3" label="自考交大普通本科二学历学生" />
                                    <el-option :value="4" label="自考其他学生" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="form-title">本人毕业证等信息</div>
                    <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item label="专业名称" prop="pro_degree_id">
                                <el-select v-model="professionalDegree" placeholder="请选择专业名称" style="width:100%"
                                    clearable filterable @change="professionalDegreeChange">
                                    <el-option v-for="item in professionalDegreeList" :key="item.id" :value="
                                            item.id + ',' +
                                            item.profession_code + ',' + item.profession_title + ',' +
                                            item.degree_id + ',' + item.degree_code + ',' + item.degree_title"
                                        :label="item.profession_title" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="8">
                            <el-form-item label="毕业证照片" prop="graduationPictures">
                                <div style="width: 100%;">
                                    <el-upload
                                        :class="['upload', {'no': !isShowAdd}]"
                                        action=""
                                        list-type="picture-card"
                                        :file-list="graduationPicturesFileList"
                                        :http-request="upLoadChange"
                                        :show-file-list="true"
                                        :on-remove="handleRemove"
                                        :on-preview="handlePreview"
                                    >
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="8">
                            <el-form-item label="学制" prop="edu_system">
                                <el-select v-model="ruleForm.edu_system" placeholder="请选择学制" clearable filterable
                                    style="width:100%">
                                    <el-option v-for="item in eduSystemList" :key="item" :value="item" :label="item" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="学习形式" prop="study_code">
                                <el-select v-model="learningForm" placeholder="请选择学习形式" style="width:100%" clearable
                                    filterable @change="learningFormChange">
                                    <el-option value="07-自考" label="自考" />
                                    <el-option value="04-函授" label="函授" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="8">
                            <el-form-item label="获学位日期" prop="obtain_date">
                                <el-date-picker v-model="ruleForm.obtain_date" type="date" value-format="yyyy-MM-dd"
                                    placeholder="请选择获学位日期" clearable style="width:100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col> -->
                        <!-- <el-col :span="8" v-if="ruleForm.study_code !== ''">
                            <el-form-item label="原学号" prop="student_code_old">
                                <el-input style="flex: 8" v-model="ruleForm.student_code_old" placeholder="请输入原学号"
                                    clearable></el-input>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="8" v-if="ruleForm.study_code == '07'">
                            <el-form-item label="毕业证书编号" prop="exam_number" :rules="[{ required: true, message: '请输入毕业证书编号', trigger: 'blur' }]">
                                <el-input style="flex: 8" v-model="ruleForm.exam_number" placeholder="请输入毕业证书编号"
                                    clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="ruleForm.study_code == '04'">
                            <el-form-item label="入学年月" prop="admission_date">
                                <el-date-picker v-model="ruleForm.admission_date" type="date" value-format="yyyy-MM-dd"
                                    placeholder="请选择入学年月" clearable style="width:100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="毕业年月" prop="gra_date">
                                <el-date-picker v-model="ruleForm.gra_date" type="date" value-format="yyyy-MM-dd"
                                    placeholder="请选择毕业年月" clearable style="width:100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="ruleForm.study_code == '04'">
                            <el-form-item label="学号" prop="student_code">
                                <el-input style="flex: 8" v-model="ruleForm.student_code" placeholder="请输入学号(12位)"
                                    clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="ruleForm.study_code == '04'">
                            <el-form-item label="考生号" prop="exam_number">
                                <el-input style="flex: 8" v-model="ruleForm.exam_number" placeholder="请输入考生号(16位)" clearable>
                                </el-input>
                                <p style="font-size: 12px;color: #666;">说明：在交大学生学习平台查询自己的16位考生号，参考例图</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="ruleForm.study_code == '04'">
                            <el-form-item label="例图">
                                <el-image
                                    :src="require('../../../assets/images/onlineDeclaration-exam-number1.jpg')"
                                    fit="contain"
                                    :preview-src-list="[require('../../../assets/images/onlineDeclaration-exam-number1.jpg')]"
                                    style="width: 100px;height: 100px;">
                                </el-image>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="毕业证盖章页照" prop="grad_img">
                                <div style="width: 100%;">
                                    <el-upload :class="['upload', {'no': !isShowAddGradImg}]" action=""
                                        list-type="picture-card" :file-list="gradImgFileList"
                                        :accept="accept"
                                        :http-request="(file) => upLoadChange(file, 'grad_img')" :show-file-list="true"
                                        :on-remove="(file, fileList) => handleRemove(file, fileList, 'grad_img')"
                                        :on-preview="handlePreview">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="form-title">各类成绩信息</div>
                    <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item label="学位英语/计算机成绩" prop="isEnglishOrComputer">
                                <el-select v-model="ruleForm.isEnglishOrComputer" placeholder="请选择学位英语/计算机成绩" style="width:100%" clearable
                                    filterable @change="isEnglishOrComputerChange">
                                    <el-option v-for="(item, index) in englishOrComputerList" :key="index" :value="item.value" :label="item.label" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="60" v-if="ruleForm.isEnglishOrComputer == 'english'">
                        <el-col :span="8">
                            <el-form-item label="学位英语考试时间" prop="english_at">
                                <el-date-picker v-model="ruleForm.english_at" type="date" value-format="yyyy-MM-dd"
                                    placeholder="请选择学位英语考试时间" clearable style="width:100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="学位英语考试合格证照片" prop="english_img">
                                <div style="width: 100%;">
                                    <el-upload :class="['upload', {'no': !isShowAddEnglish}]" action=""
                                        list-type="picture-card" :file-list="englishFileList"
                                        :accept="accept"
                                        :http-request="(file) => upLoadChange(file, 'english_img')"
                                        :show-file-list="true"
                                        :on-remove="(file, fileList) => handleRemove(file, fileList, 'english_img')"
                                        :on-preview="handlePreview">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="60" v-if="ruleForm.isEnglishOrComputer == 'computer'">
                        <el-col :span="8">
                            <el-form-item label="计算机等级考试时间" prop="computer_at">
                                <el-date-picker v-model="ruleForm.computer_at" type="date" value-format="yyyy-MM-dd"
                                    placeholder="请选择计算机等级考试时间" clearable style="width:100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="计算机等级考试合格证照片" prop="computer_img">
                                <div style="width: 100%;">
                                    <el-upload :class="['upload', {'no': !isShowAddComputer}]" action=""
                                        list-type="picture-card" :file-list="computerFileList"
                                        :accept="accept"
                                        :http-request="(file) => upLoadChange(file, 'computer_img')"
                                        :show-file-list="true"
                                        :on-remove="(file, fileList) => handleRemove(file, fileList, 'computer_img')"
                                        :on-preview="handlePreview">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item label="平均成绩" prop="average_score">
                                <el-input style="flex: 8" v-model="ruleForm.average_score" placeholder="请输入平均成绩"
                                    clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="论文成绩" prop="paper_score">
                                <el-input style="flex: 8" v-model="ruleForm.paper_score" placeholder="请输入论文成绩"
                                    clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item label="成绩总表" prop="score_img">
                                <div style="width: 100%;">
                                    <el-upload :class="['upload', {'no': !isShowAddScore}]" action=""
                                        list-type="picture-card" :file-list="scoreImgFileList"
                                        :accept="accept"
                                        :http-request="(file) => upLoadChange(file, 'score_img')" :show-file-list="true"
                                        :on-remove="(file, fileList) => handleRemove(file, fileList, 'score_img')"
                                        :on-preview="handlePreview">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="form-title">毕业论文(设计)信息提交</div>
                    <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item class="item-box line" label="导师姓名" prop="mentor_title">
                                <el-input
                                    v-model="ruleForm.mentor_title"
                                    placeholder="请输入导师姓名"
                                    clearable
                                    maxlength="60"
                                    show-word-limit
                                ></el-input>
                                <span class="item-tips">备注：允许多个导师，兼容中英文，用中文或英文分号分隔，120字符内</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item  class="item-box line" label="论文类型" prop="paper_type">
                                <el-select v-model="ruleForm.paper_type" placeholder="请选择论文类型" style="width:100%" clearable filterable>
                                    <el-option value="毕业论文" label="毕业论文" />
                                    <el-option value="毕业设计" label="毕业设计" />
                                </el-select>
                                <span class="item-tips">备注：参考资料库标准表</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item class="item-box line" label="论文题目" prop="paper_title">
                                <el-input
                                    v-model="ruleForm.paper_title"
                                    placeholder="请输入论文题目"
                                    clearable
                                    maxlength="120"
                                    show-word-limit
                                ></el-input>
                                <span class="item-tips">备注：240字符内</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item class="item-box line" label="论文关键词" prop="paper_key">
                                <el-input
                                    v-model="ruleForm.paper_key"
                                    placeholder="请输入论文关键词"
                                    clearable
                                    maxlength="60"
                                    show-word-limit
                                ></el-input>
                                <span class="item-tips">备注：3-5个关键词，每个关键词之间用中文或英文分号分隔开，120字符内</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item class="item-box line" label="论文选题来源" prop="paper_topic">
                                <el-input
                                    v-model="ruleForm.paper_topic"
                                    placeholder="请输入论文选题来源"
                                    clearable
                                    maxlength="15"
                                    show-word-limit
                                ></el-input>
                                <span class="item-tips">备注：统一填“其他”</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item class="item-box line" label="论文研究方向" prop="paper_research">
                                <el-input
                                    v-model="ruleForm.paper_research"
                                    placeholder="请输入论文研究方向"
                                    clearable
                                    maxlength="40"
                                    show-word-limit
                                ></el-input>
                                <span class="item-tips">备注：最多可填2个方向，用中文或英文分号分隔，80个字符内</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item class="item-box line" label="论文撰写语种" prop="paper_lang">
                                <el-select v-model="ruleForm.paper_lang" placeholder="请选择论文撰写语种" style="width:100%" clearable filterable>
                                    <el-option value="中文" label="中文" />
                                    <el-option value="英文" label="英文" />
                                </el-select>
                                <span class="item-tips">备注：参考资料库标准表</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="form-title">学位证书用电子照片</div>
                    <el-row :gutter="60">
                        <!-- <el-col :span="8">
                            <el-form-item label="学位证书编号" prop="degree_number">
                                <el-input style="flex: 8" v-model="ruleForm.degree_number" placeholder="请输入学位证书编号"
                                    clearable></el-input>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="8">
                            <!-- label="学位证书用电子照片" -->
                            <el-form-item  prop="degree_img">
                                <div style="width: 100%;">
                                    <el-upload :class="['upload', {'no': !isShowAddDegree}]" action=""
                                        list-type="picture-card" :file-list="degreeFileList"
                                        :accept="accept"
                                        :http-request="(file) => upLoadChange(file, 'degree_img')"
                                        :show-file-list="true"
                                        :on-remove="(file, fileList) => handleRemove(file, fileList, 'degree_img')"
                                        :on-preview="handlePreview">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <div class="color-red">
                                <p>注意：</p>
                                <p>
                                    1、纸质小2寸照片，必须与本科毕业证照片一致。（
                                    <span>毕业证照片可在</span>
                                    <a href="https://www.chsi.com.cn/" target="_blank">
                                        <span class="color-blue">学信网</span>
                                    </a>
                                    <span>上截取</span>
                                    ）
                                </p>
                                <p>2、电子照片（必须命名为  张 三 513132199210121028.jpg），
                                    <span>电子照片大小为10一40KB且像素尺寸为（宽）480*（高）640，图片必须用jpg格式</span>。电子照片在网上申报时提交。</p>
                                <p>3、申请学位所需电子照片格式不符合要求者，将无法完成学位信息网上报送工作！</p>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="form-title">其他信息</div>
                    <el-row :gutter="60">
                        <el-col :span="16">
                            <el-form-item label="备注" prop="remark">
                                <el-input style="flex: 8" v-model="ruleForm.remark" type="textarea" rows="4"
                                    placeholder="请输入备注" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="btn">
                <el-button type="primary" class="btn" @click="submit">提交</el-button>
            </div>
        </div>
        <!-- 图片预览 -->
        <el-dialog width="40%" :visible.sync="dialogVisible">
            <div style="text-align: center;">
                <img style="max-width: 100%;" :src="dialogImageUrl" alt="图片" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { putObject } from "@/utils/upload.js";
import {
    studentDaNation,
    studentDaProDegree,
    studentDaPost,
} from "@/api/degreeApplication";
export default {
    name: "onlineDeclaration",
    data() {
            const validateStudentCode = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入学号'));
            } else {
                if (this.ruleForm.student_code.length != 12) {
                    callback(new Error('学号格式不正确，学号为12位'));
                }
                callback();
            }
        };
        return {
            accept: '.jpg,.jpeg,.png,.JPG,.JPEG,.bmp,.gif,.webp,.psd,.svg,.tiff',

            englishOrComputerList: [
                {label: '学位英语合格资料', value: 'english'},
                {label: '计算机等级合格资料', value: 'computer'},
            ],
            
            ruleForm: {
                student_id: "", //学生id
                sc_id: "", //学生在班id
                class_id: "", //班级id
                class_title: "", //班级名称
                student_title: "", //学生姓名
                tel: "", //电话
                sex: 1, //性别
                nat_id: "", //民族
                nat_code: "", //民族代码
                nat_title: "", //民族名称
                pol_code: "", // 政治面貌 党员: 01 群众: 13
                pol_title: "", //政治面貌
                date_birth: "", //出生日期
                // cert_type: '',  //证件类型 身份证: 01
                identity: "", //身份证
                source_type: "", //学生来源  1 成教上清寺高教自考辅导学 2成教其他 3 自考普通本科 4自考其他

                pro_degree_id: "", //专业学位id
                pro_code: "", //专业代码
                pro_title: "", //专业名称
                degree_id: "", //学位id
                degree_code: "", //学位代码
                degree_title: "", //学位名称
                admission_date: "", //入学年月
                student_code: "", //学号
                edu_system: "", //学制
                study_code: "", //学习形式代码  自考: 07  函授: 04
                study_title: "", //学习形式名称
                gra_date: "", //毕业年月
                // obtain_date: "", //获学位日期
                // student_code_old: "", //原学号
                exam_number: "", //考生号

                english_at: "", //英语学位考试时间
                english_img: "", //学位英语考试合格证照片
                computer_at: "", //计算机学位考试时间
                computer_img: "", //计算机等级考试合格证照片
                // degree_number: "", //学位证书编号
                degree_img: "", //学位证书用电子照片
                average_score: "", //平均成绩
                paper_score: "", //论文成绩
                score_img: "", //成绩总表
                grad_img: "",  //毕业证盖章页照

                mentor_title: '',  //导师姓名
                paper_type: '',  //论文类型
                paper_title: '',  //论文题目
                paper_key: '',  //论文关键词
                paper_topic: '其他',  //论文选题来源
                paper_research: '',  //论文研究方向
                paper_lang: '',  //论文撰写语种

                remark: "", //备注
                isEnglishOrComputer: '',  //学位英语/计算机成绩

            },
            nation: "", //民族
            sex: "", //性别
            politicalOutlook: "", //政治面貌
            professionalDegree: "", //专业名称
            learningForm: "", //学习形式
            rules: {
                student_title: [
                    { required: true, message: "请输入姓名", trigger: "blur" },
                ],
                mentor_title: [{ required: true, message: "请输入导师姓名", trigger: "blur" }],
                paper_type: [{ required: true, message: "请选择论文类型", trigger: "change" }],
                paper_title: [{ required: true, message: "请输入论文题目", trigger: "blur" }],
                paper_key: [{ required: true, message: "请输入论文关键词", trigger: "blur" }],
                paper_topic: [{ required: true, message: "请输入论文选题来源", trigger: "blur" }],
                paper_research: [{ required: true, message: "请输入论文研究方向", trigger: "blur" }],
                paper_lang: [{ required: true, message: "请选择论文撰写语种", trigger: "change" }],
                isEnglishOrComputer: [{ required: true, message: "请选择学位英语/计算机成绩", trigger: "change" }],

                nat_id: [
                    {
                        required: true,
                        message: "请选择民族",
                        trigger: "change",
                    },
                ],
                identity: [
                    {
                        required: true,
                        message: "请输入身份证",
                        trigger: "blur",
                    },
                ],
                tel: [
                    {
                        required: true,
                        message: "请输入移动电话",
                        trigger: "blur",
                    },
                ],
                sex: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: "change",
                    },
                ],
                pol_code: [
                    {
                        required: true,
                        message: "请选择政治面貌",
                        trigger: "change",
                    },
                ],
                date_birth: [
                    {
                        required: true,
                        message: "请选择出生日期",
                        trigger: "change",
                    },
                ],
                source_type: [
                    {
                        required: true,
                        message: "请选择学生来源",
                        trigger: "change",
                    },
                ],

                pro_degree_id: [
                    {
                        required: true,
                        message: "请选择专业名称",
                        trigger: "change",
                    },
                ],
                admission_date: [
                    {
                        required: true,
                        message: "请选择入学年月",
                        trigger: "change",
                    },
                ],
                edu_system: [
                    {
                        required: true,
                        message: "请选择学制",
                        trigger: "change",
                    },
                ],
                study_code: [
                    {
                        required: true,
                        message: "请选择学习形式",
                        trigger: "change",
                    },
                ],
                gra_date: [
                    {
                        required: true,
                        message: "请选择毕业年月",
                        trigger: "change",
                    },
                ],
                // obtain_date: [
                //     {
                //         required: true,
                //         message: "请选择获学位日期",
                //         trigger: "change",
                //     },
                // ],
                // student_code_old: [
                //     {
                //         required: true,
                //         message: "请输入原学号",
                //         trigger: "blur",
                //     },
                // ],
                student_code: [
                    {
                        required: true,
                        // message: "请输入学号",
                        trigger: "blur",
                        validator: validateStudentCode
                    },
                ],
                exam_number: [
                    {
                        required: true,
                        message: "请输入考生号",
                        trigger: "blur",
                    },
                ],

                english_at: [
                    {
                        required: true,
                        message: "请选择英语学位考试时间",
                        trigger: "change",
                    },
                ],
                english_img: [
                    {
                        required: true,
                        message: "请选择学位英语考试合格证照片",
                        trigger: "change",
                    },
                ],
                computer_at: [
                    {
                        required: true,
                        message: "请选择计算机学位考试时间",
                        trigger: "change",
                    },
                ],
                computer_img: [
                    {
                        required: true,
                        message: "请选择计算机等级考试合格证照片",
                        trigger: "change",
                    },
                ],
                // degree_number: [
                //     {
                //         required: true,
                //         message: "请输入学位证书编号",
                //         trigger: "blur",
                //     },
                // ],
                degree_img: [
                    {
                        required: true,
                        message: "请选择学位证书用电子照片",
                        trigger: "change",
                    },
                ],
                score_img: [
                    {
                        required: true,
                        message: "请选择成绩总表",
                        trigger: "change",
                    },
                ],
                grad_img: [
                    {
                        required: true,
                        message: "请选择毕业证盖章页照",
                        trigger: "change",
                    },
                ],
                average_score: [
                    {
                        required: true,
                        message: "请输入平均成绩",
                        trigger: "blur",
                    },
                ],
                paper_score: [
                    {
                        required: true,
                        message: "请输入论文成绩",
                        trigger: "blur",
                    },
                ],

                remark: [
                    { required: true, message: "请输入备注", trigger: "blur" },
                ],
            },
            nationList: [], //民族 列表
            professionalDegreeList: [], //专业学位 列表
            //学制
            eduSystemList: [2, 2.5, 5],
            // 学制
            yearList: [
                { name: "2", value: "2" },
                { name: "2.5", value: "2.5" },
                { name: "5", value: "5" },
            ],
            graduationPicturesFileList: [], //毕业证照片 选中列表
            isShowAdd: true, //显示上传添加
            // isShowGraduationPictures: true,  //毕业证照片 选中状态

            isShowAddEnglish: true, //英语学位照片 显示上传添加
            englishFileList: [], //英语学位照片 选中列表
            isShowAddComputer: true, //计算机学位照片 显示上传添加
            computerFileList: [], //计算机学位照片 选中列表
            isShowAddDegree: true, //学位证书照片 显示上传添加
            degreeFileList: [], //学位证书照片 选中列表
            isShowAddScore: true, //成绩总表 显示上传添加
            scoreImgFileList: [],  //成绩总表选中列表
            isShowAddGradImg: true, //毕业证盖章页照 显示上传添加
            gradImgFileList: [],  //毕业证盖章页照 选中列表

            dialogVisible: false,
            dialogImageUrl: "",
        };
    },
    watch: {
        // 'ruleForm.graduationPictures': {
        //     deep: true,
        //     handler(v){
        //         if(v){
        //             this.isShowGraduationPictures = false;
        //         }
        //     }
        // },
    },
    created() {
        // this.$store.dispatch("common/getS3ClientAction"); // 获取腾讯云签名
        this.getsNation(); //获取民族
        this.getProfessionalDegreeList(); //获取专业学位
    },
    methods: {
        // 选择学位英语/计算机成绩
        isEnglishOrComputerChange(v){
            if(this.ruleForm.isEnglishOrComputer === 'english'){
                this.ruleForm.computer_at = '';
                this.ruleForm.computer_img = '';
            }else if(this.ruleForm.isEnglishOrComputer === 'computer'){
                this.ruleForm.english_at = '';
                this.ruleForm.english_img = '';
            }
        },
        // 提交
        submit() {
            this.$refs["ruleForm"].validate(async (valid) => {
                if (valid) {
                    let data = this.ruleForm;
                    studentDaPost(data).then((res) => {
                        if (res.code == 200) {
                            this.$message.success("操作成功");
                            this.$emit("submitSuccess");
                        }
                    });
                }
            });
        },
        // 照片 上传
        upLoadChange(file, type) {
            // this.isShowAdd = false;
            let name = file.file.name;
            let fileType = name.substring(name.lastIndexOf("."));
            let acceptArr = this.accept.split(",");
            if (acceptArr.indexOf(fileType) == -1) {
                this.$message({
                    // message: `上传文件只能是${this.accept}格式!`,
                    message: '上传图片格式不正确',
                    type: "warning",
                });
                switch (type) {
                    case "english_img":
                        this.englishFileList = [];
                        break;
                    case "computer_img":
                        this.computerFileList = [];
                        break;
                    case "degree_img":
                        this.degreeFileList = [];
                        break;
                    case "score_img":
                        this.scoreImgFileList = [];
                        break;
                    case "grad_img":
                        this.gradImgFileList = [];
                        break;
                }
                return;
            }
            switch (type) {
                case "english_img":
                    this.isShowAddEnglish = false;
                    break;
                case "computer_img":
                    this.isShowAddComputer = false;
                    break;
                case "degree_img":
                    this.isShowAddDegree = false;
                    break;
                case "score_img":
                    this.isShowAddScore = false;
                    break;
                case "grad_img":
                    this.isShowAddGradImg = false;
                    break;
            }
            putObject(
                file,
                (url) => {
                    if (url) {
                        // this.ruleForm.graduationPictures = url;
                        switch (type) {
                            case "english_img":
                                this.ruleForm.english_img = url;
                                break;
                            case "computer_img":
                                this.ruleForm.computer_img = url;
                                break;
                            case "degree_img":
                                this.ruleForm.degree_img = url;
                                break;
                            case "score_img":
                                this.ruleForm.score_img = url;
                                break;
                            case "grad_img":
                                this.ruleForm.grad_img = url;
                                break;
                        }
                    }
                },
                null,
                "student",
                fileType
            );
        },
        // 毕业证照片 移除
        handleRemove(file, fileList, type) {
            // this.isShowAdd = true;
            switch (type) {
                case "english_img":
                    this.isShowAddEnglish = true;
                    break;
                case "computer_img":
                    this.isShowAddComputer = true;
                    break;
                case "degree_img":
                    this.isShowAddDegree = true;
                    break;
                case "score_img":
                    this.isShowAddScore = true;
                    break;
                case "grad_img":
                    this.isShowAddGradImg = true;
                    break;
            }
        },
        // 预览
        handlePreview(file) {
            this.dialogVisible = true;
            this.dialogImageUrl = file.url;
        },
        // 选中 学习形式
        learningFormChange(v) {
            let study_code = v.split("-")[0];
            let study_title = v.split("-")[1];
            this.ruleForm.study_code = study_code;
            this.ruleForm.study_title = study_title;
            if (study_code == "07") {
                //自考
                this.ruleForm.type = 1;
            } else if (study_code == "04") {
                this.ruleForm.type = 2;
            }
        },
        // 选中 专业学位
        professionalDegreeChange(v) {
            let pro_degree_id = v.split(",")[0];
            let pro_code = v.split(",")[1];
            let pro_title = v.split(",")[2];
            let degree_id = v.split(",")[3];
            let degree_code = v.split(",")[4];
            let degree_title = v.split(",")[5];
            this.ruleForm.pro_degree_id = pro_degree_id;
            this.ruleForm.pro_code = pro_code;
            this.ruleForm.pro_title = pro_title;
            this.ruleForm.degree_id = degree_id;
            this.ruleForm.degree_code = degree_code;
            this.ruleForm.degree_title = degree_title;
        },
        // 选中 政治面貌
        polChange(v) {
            let pol_code = v.split("-")[0];
            let pol_title = v.split("-")[1];
            this.ruleForm.pol_code = pol_code;
            this.ruleForm.pol_title = pol_title;
        },
        // 选中 性别
        sexChange(v) {
            let sex = v.split("-")[0];
            let sex_title = v.split("-")[1];
            this.ruleForm.sex = sex;
            this.ruleForm.sex_title = sex_title;
        },
        // 选中 民族
        natChange(v) {
            let nat_id = v.split("-")[0];
            let nat_code = v.split("-")[1];
            let nat_title = v.split("-")[2];
            this.ruleForm.nat_id = nat_id;
            this.ruleForm.nat_code = nat_code;
            this.ruleForm.nat_title = nat_title;
        },
        // 获取专业学位
        getProfessionalDegreeList() {
            studentDaProDegree().then((res) => {
                if (res.code == 200) {
                    this.professionalDegreeList = res.result;
                }
            });
        },
        // 获取民族
        getsNation() {
            studentDaNation().then((res) => {
                if (res.code == 200) {
                    this.nationList = res.result;
                }
            });
        },
    },
};
</script>

<style lang="scss">
.onlineDeclaration {
    .cont {
        .el-upload {
            width: 100%;
            // text-align: left;
        }
        .el-upload--picture-card {
            width: 80px;
            height: 80px;
            line-height: 80px;
            margin-top: 5px;

            .el-icon-plus {
                line-height: inherit;
            }
        }
        .el-upload-list--picture-card .el-upload-list__item {
            width: 80px;
            height: 80px;
            // margin: 0 8px 8px 0;
            margin: 0;
            margin-top: 5px;
            display: inline-block;
        }
        .upload.no {
            .el-upload--picture-card {
                display: none;
            }
        }
        .item-box.line{
            // .el-form-item__label{
            //     width: 100%;
            //     text-align: left;
            // }
            // .el-input{
            //     width: calc(50% - 30px);
            // }
            // .item-tips{
            //     margin-left: 10px;
            //     font-size: 12px;
            //     color: #666;
            // }
            position: relative;
            .item-tips{
                white-space: nowrap;
                position: absolute;
                top: 40px;
                left: calc(100% + 10px);
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.onlineDeclaration {
    padding: 20px;
    .top {
        .onlineDeclaration-img {
            width: 150px;
            height: 100px;
            object-fit: contain;
        }
    }
    .tips {
        margin-top: 20px;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #3c99d8;
    }
    .cont {
        margin-top: 20px;
        font-size: 16px;
        .cont-title {
            font-size: 18px;
            font-weight: 500;
        }
        .form-box {
            padding: 20px;
        }
        .form-title {
            font-size: 18px;
            font-weight: 700;
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #eee;
            margin-top: 20px;
        }
        .btn {
            margin-left: 10px;
        }
        .color-red{
            color: rgb(255, 0, 0);
        }
        .color-blue{
            color: #006dcc;
        }
        a:visited {
            color: #006dcc;
        }
        a:active, a:hover {
            color: #33a0ff;
        }
    }
}
</style>
